import List from '@utils/list'
const { Jurisdiction, Table } = List

const addPercentage = ({ value }: {value: any}) => value + '%'

const jurisdiction = new Jurisdiction()
  .lib('add').to('Performance.NumberFormula.Add')
  .lib('modify').modify('Performance.NumberFormula.Modify')
  .lib('delete').del('/srmRationFormula/deleteSrmRationFormulaByIds', process.env.VUE_APP_PURCHASE_API)

const table = new Table('performance.numberFormula')
  .add('rationFormulaName')
  .add('qualifiedBatchWeight').format(addPercentage)
  .add('qualifiedReceiptWeight').format(addPercentage)
  .add('expectedDeliveryWeight').format(addPercentage)
  .add('committedDeliveryWeight').format(addPercentage)
  .add('priceDifferenceWeight').format(addPercentage)
  .lib('remarks')

export default new List()
  .url('/srmRationFormula/getSrmRationFormulaPageByParams', process.env.VUE_APP_PURCHASE_API)
  .jurisdiction(jurisdiction)
  .table(table)
  .end()
